module.exports = __webpack_public_path__ + "img/1492775080.5da29a80.jpg";